import React, { useState } from 'react';
import './MenuPopupDeliveryAdd.scss';
import './MenuPopupDeliveryAdd-media.scss';
import { AddMenu } from './constants';

import Button from '../../Button/Button';
import { ClosedSubMenuComponent, bodyAuto } from '../../../services/GlobalFunctions';
import { createPortal } from 'react-dom';
import ModalFormFeedback from '../../ModalFormFeedback/ModalFormFeedback';
import { SelectValuesFormSimple } from '../../../services/content/Constants';
import {content} from "../../../services/content";
import {Link} from "../../Link/Link";
import {IMenu} from "../../../redux/initState/InterfacesState";
import MenuGroup from '../MenuGroup/MenuGroup';

interface Props {
  addMenuData?: any;
}

const MenuPopupDeliveryAdd = ({ addMenuData }: Props) => {
  const [showModalPartner, setShowModalPartner] = useState(false);

  // Get menu items from WordPress (children[1]) or fallback to hardcoded
  const getMenuItems = (): IMenu[] => {
    if (addMenuData?.children?.[1] && Array.isArray(addMenuData.children[1]) && addMenuData.children[1].length > 0) {
      return addMenuData.children[1]
        .filter((item: any) => item && item.title && item.url)
        .map((item: any) => ({
          text: item.title,
          link: item.url,
          children: item.children,
        }));
    }
    return AddMenu;
  };

  const menuItems = getMenuItems();

  const openModal = () => {
    setShowModalPartner(true);
    ClosedSubMenuComponent();
  };

  const closedModal = () => {
    bodyAuto();
    setShowModalPartner(false);
    ClosedSubMenuComponent();
  };

  return (
    <div className="menu-popup-delivery-add">
      <div className="menu-popup-delivery-add__links">
        {menuItems.map(({ text, link, children }, i) =>
          children?.length ? (
            <MenuGroup item={{ title: text, url: link, children }} onClickLink={ClosedSubMenuComponent} key={i} />
          ) : (
            <Link to={link} className="menu-popup-delivery-add__link" key={i} onClick={ClosedSubMenuComponent}>
              <p dangerouslySetInnerHTML={{ __html: text }}></p>
            </Link>
          )
        )}
      </div>

      <div className="menu-popup-delivery-add__buttons">
        {/* <Button
          text="Калькулятор"
          link={EnumUrlsPages.calculator}
          onClick={ClosedSubMenuComponent}
          type="border"
          size="S"
          widthAll
        /> */}
      </div>

      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showModalPartner}
          id="partner"
          title={content.header.textBecomePartner}
          select={{
            options: [],
            disabled: true,
            active: SelectValuesFormSimple.find((x) => x.eventMetrika === 'form_partner'),
          }}
          closedModal={closedModal}
          eventMetrika="form_partner"
          sendAmoCRM
        />,
        document.body
      )}
    </div>
  );
};

export default MenuPopupDeliveryAdd;
